import React, { lazy, Suspense } from 'react';

const LazyRegisterAccount = lazy(() => import('./RegisterAccount'));

const RegisterAccount = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyRegisterAccount {...props} />
  </Suspense>
);

export default RegisterAccount;
